import React from 'react';
import { string, number, func, array } from 'prop-types';

import SinglePayElementAtTargetTable from '../../PayElementTables/PayElementAtTargetTable/SinglePayElementAtTargetTable';
import SurveyJobInformation from '../SurveyJobInformation/SurveyJobInformation';
import { surveyJobMatch as surveyJobMatchPropType } from '../../propTypes';

import './SurveyJobMatch.scss';

class SurveyJobMatch extends React.Component {
  constructor(props) {
    super(props);

    this._onClick = this._onClick.bind(this);
  }

  static propTypes = {
    selectedPayElement: string,
    surveyJob: surveyJobMatchPropType,
    monetaryRounding: number,
    percentRounding: number,
    showSurveyJobDrilldownAction: func,
    pricingData: array
  };

  _onClick() {
    const { surveyJob, showSurveyJobDrilldownAction } = this.props;
    showSurveyJobDrilldownAction(surveyJob);
  }

  render() {
    const { selectedPayElement, surveyJob, monetaryRounding, percentRounding, pricingData } = this.props;
    const { metadata } = surveyJob;

    return (
      <div className="survey-job-match" onClick={this._onClick}>
        <SurveyJobInformation metadata={metadata} />
        <SinglePayElementAtTargetTable
          pricingData={pricingData}
          data={surveyJob[selectedPayElement]}
          monetaryRounding={monetaryRounding}
          percentRounding={percentRounding}
        />
      </div>
    );
  }
}

export default SurveyJobMatch;
